__turbopack_context__.v({
  "articleArrow": "OuhFoW_articleArrow",
  "collection": "OuhFoW_collection",
  "count": "OuhFoW_count",
  "empty": "OuhFoW_empty",
  "emptyIcon": "OuhFoW_emptyIcon",
  "error": "OuhFoW_error",
  "list": "OuhFoW_list",
  "meta": "OuhFoW_meta",
  "page": "OuhFoW_page",
  "pageHeader": "OuhFoW_pageHeader",
  "saveButton": "OuhFoW_saveButton",
  "saveControl": "OuhFoW_saveControl",
  "source": "OuhFoW_source",
  "storageNote": "OuhFoW_storageNote",
  "titleRow": "OuhFoW_titleRow",
  "toolbar": "OuhFoW_toolbar",
});
